import { MessageSquare, QrCode } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import styles from '../../../assets/scss/pages/FeedbackPage.module.scss';

export default function FeedbackIndex() {
    const navigate = useNavigate();

    return (
        <div className={styles.page}>
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                    <h1 className={styles.title}>Đánh giá</h1>
                    <p className={styles.subtitle}>Quản lý QR đánh giá và phản hồi từ khách hàng</p>
                </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 20, maxWidth: 700 }}>
                <div style={{
                    background: '#fff', border: '2px solid #ECEEF2', borderRadius: 16,
                    padding: '28px 24px', cursor: 'pointer', transition: 'all 0.15s',
                }} onClick={() => navigate('/admin/feedback/qr')}
                    onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#0098F6'; e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.06)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#ECEEF2'; e.currentTarget.style.boxShadow = 'none'; }}
                >
                    <div style={{
                        width: 48, height: 48, borderRadius: 12, background: 'rgba(0,152,246,0.1)',
                        color: '#0098F6', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16,
                    }}><QrCode size={24} /></div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: '#1A1A1A', marginBottom: 6 }}>QR đánh giá</div>
                    <div style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.5 }}>
                        QR được nhân viên gửi cho khách hàng sau khi tạo đơn xong khoảng 30 phút để khách đánh giá chất lượng dịch vụ.
                    </div>
                </div>

                <div style={{
                    background: '#fff', border: '2px solid #ECEEF2', borderRadius: 16,
                    padding: '28px 24px', cursor: 'pointer', transition: 'all 0.15s',
                }} onClick={() => navigate('/admin/feedback/reviews')}
                    onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#0098F6'; e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.06)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#ECEEF2'; e.currentTarget.style.boxShadow = 'none'; }}
                >
                    <div style={{
                        width: 48, height: 48, borderRadius: 12, background: 'rgba(245,158,11,0.1)',
                        color: '#F59E0B', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16,
                    }}><MessageSquare size={24} /></div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: '#1A1A1A', marginBottom: 6 }}>Đánh giá</div>
                    <div style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.5 }}>
                        Phản hồi từ khách hàng trở lại cửa hàng, giúp chủ cửa hàng theo dõi nhân viên và chất lượng dịch vụ.
                    </div>
                </div>
            </div>
        </div>
    );
}
